import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

// 📌 GÜNCELLEME 1: OData yerine güvenli Auth API POST isteği
const loginApi = async (email, password) => {
  const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/api/auth/login`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json' 
    },
    body: JSON.stringify({
      LoginValue: email,
      Password: password
    })
  });

  console.log("Login API Response Status:", response.status); // Debug için ekledik
  if (response.status === 401) {
    throw new Error("E-posta veya şifre hatalı.");
  }
  
  if (!response.ok) {
    throw new Error(`Sunucu hatası: ${response.status}`);
  }

  return await response.json();
};

// 📌 GÜNCELLEME 2: Response yapısına göre Saga fonksiyonu
function* loginUser({ payload: { user, history } }) {
  try {
    const data = yield call(loginApi, user.email, user.password);

    console.log("API'den dönen veri:", data); // Debug için ekledik
    // API'den { Token, KullaniciVerileri } dönmesini bekliyoruz
    if (data && data.Token && data.KullaniciVerileri) {
      
      // Kullanıcı verilerine token'ı da ekleyerek objeyi birleştiriyoruz
      const loggedInUser = {
        ...data.KullaniciVerileri,
        Token: data.Token 
      };
      
      // LocalStorage kayıtları
      localStorage.setItem("authUser", JSON.stringify(loggedInUser));
      localStorage.setItem("token", data.Token); // Gelecekteki API istekleri için token'ı ayrıca tutmak iyi bir pratiktir
      
      yield put(loginSuccess(loggedInUser));
      
      // Başarılı girişte yönlendirme
      history('/dashboard'); 
    } else {
      yield put(apiError("Sunucudan geçersiz veri döndü."));
    }
  } catch (error) {
    yield put(apiError(error.message || "Giriş hatası."));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("token"); // Token'ı da temizliyoruz
    yield put(logoutUserSuccess());
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

// Social Login şimdilik devre dışı bırakılabilir
function* socialLogin({ payload: { type, history } }) {
  try {
    yield put(apiError("Sosyal giriş şu anda desteklenmemektedir."));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;